import { links } from 'bzx-common/src/config/appConfig'
import { observer } from 'mobx-react'
import React from 'react'
import ExternalLink from 'shared-components/ExternalLink'
import { Button, Icon } from 'ui-framework'
import BZRXCompensation from './BZRXCompensation'
import BZRXCompensationBSC from './BZRXCompensationBSC'
import CompensationDetails from './CompensationDetails'
import CompensationVM, { CompensationTab } from './CompensationVM'
import P125Compensation from './P125Compensation'

const tabs: { id: CompensationTab; label: string; icon: string }[] = [
  { id: 'bzrxOnPolygon', label: 'I lost BZRX / GOV on BSC / Polygon', icon: 'token-bzrx' },
  { id: 'bzrxOnBsc', label: 'I still have BZRX on BSC', icon: 'token-bzrx' },
  { id: 'p125', label: 'I lost other tokens than BZRX', icon: 'token-p125' },
]

export function Compensation({ vm }: { vm: CompensationVM }) {
  return (
    <div className="margin-bottom-4">
      <h2 className="title-page margin-bottom-1">Compensation</h2>

      <div className="margin-bottom-2">
        <div className="txt-read-optimized">
          <p className="txt-slogan">
            If you are a victim of the November 2021 incident, you are entitled to a compensation of
            BZRX tokens and/or Debt token.{' '}
            <Button variant="link" onClick={vm.instructionsDialog.toggle}>
              More details
            </Button>
          </p>
          <p>
            Depending on your situation you will receive multiple airdrops and must follow the
            instructions for each case.
          </p>

          <p>
            Join the{' '}
            <ExternalLink className="link--discreet" href={links.compensationChannel}>
              Compensation channel
            </ExternalLink>{' '}
            if you need help.
          </p>
        </div>
      </div>

      {vm.instructionsDialog.visible && <CompensationDetails />}

      <div className="flex-row-center flex-wrap margin-bottom-1 justify-between gap-1">
        {tabs.map((tab) => (
          <Button
            key={tab.id}
            variant="blue-inverse"
            className="btn--small-corners flex-fill flex-center"
            active={vm.tab === tab.id}
            onClick={vm.changeTab}
            onClickEmit="value"
            value={tab.id}>
            <Icon name={tab.icon} size={24} />
            <span className="margin-left-1ch">{tab.label}</span>
          </Button>
        ))}
      </div>

      {vm.tab === 'bzrxOnPolygon' && <BZRXCompensation vm={vm} />}
      {vm.tab === 'bzrxOnBsc' && <BZRXCompensationBSC vm={vm} />}
      {vm.tab === 'p125' && <P125Compensation vm={vm} />}
    </div>
  )
}

export default observer(Compensation)
